import type { ReactElement, ReactNode } from 'react';

/**
 * The v2 sidebar's icon set, path for path from the mock (built-v12
 * `aside.side nav a svg`): 24-grid strokes, 1.7 wide, round caps. Sized and
 * coloured by the parent (`.side nav a svg{width:18px;height:18px}`).
 */
function Icon({ children }: { children: ReactNode }): ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="h-[18px] w-[18px] flex-none fill-none stroke-current"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export const HomeIcon = (): ReactElement => (
  <Icon><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></Icon>
);
export const SalesIcon = (): ReactElement => (
  <Icon><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></Icon>
);
export const ProductsIcon = (): ReactElement => (
  <Icon><path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0L3 13V3h10l7.6 7.6a2 2 0 010 2.8z" /><circle cx="7.5" cy="7.5" r="1.5" /></Icon>
);
export const ReturnsIcon = (): ReactElement => (
  <Icon><path d="M9 14L4 9l5-5" /><path d="M4 9h11a5 5 0 010 10h-4" /></Icon>
);
export const OrdersIcon = (): ReactElement => (
  <Icon><path d="M21 8l-9-5-9 5 9 5 9-5z" /><path d="M3 8v8l9 5 9-5V8" /><path d="M12 13v8" /></Icon>
);
export const FinancesIcon = (): ReactElement => (
  <Icon><rect x="2" y="6" width="20" height="13" rx="2" /><path d="M2 10h20M16 15h2" /></Icon>
);
export const ReportsIcon = (): ReactElement => (
  <Icon><path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9z" /><path d="M14 3v6h6M12 12v6M9 15l3 3 3-3" /></Icon>
);
export const CatalogIcon = (): ReactElement => (
  <Icon>
    <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />
  </Icon>
);
export const SettingsIcon = (): ReactElement => (
  <Icon>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" />
  </Icon>
);
/** Not in the mock (it has no staff entry); drawn in the same stroke grammar. */
export const AdminIcon = (): ReactElement => (
  <Icon><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" /><path d="M9 12l2 2 4-4" /></Icon>
);
